import loadable from '@loadable/component';

export const ViewUnpublishedVolopPageLoadable = loadable(
  () => import('./ViewUnpublishedVolopPage'),
  { resolveComponent: (module) => module.ViewUnpublishedVolopPage },
);
